<template>
	<div
		class="container"
		style="background-color: white;">
		<div class="grid align-items-center">
			<div class="sm:col-12 md:col-6 lg:col-6 page-image-container">
				<img
					class="img-fluid page-image"
					src="../../assets/administry-connect.png"
					alt="Hospital Image" />
			</div>
			<div class="sm:col-12 md:col-6 lg:col-6 border-left pl-4">
				<div class="text-center text-uppercase font-weight-bold welcome-text">
					Bienvenue
				</div>
				<br />
				<p class="text-center">
					Ce site est exclusivement réservé aux Administrations et Ministère de la santé
				</p>
				<div class="container-login text-center pb-5">
					<Button
						class="p-button p-button-rounded submit-btn justify-content-center"
						@click.prevent="onClickLogin">
						<span>Se connecter</span>
					</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useAuthStore } from "@/store/modules/auth";
	import { useRouter } from 'vue-router';

	export default defineComponent({
		name: "LoginPage",

		data() {
			return {
				authStore: useAuthStore(),
				router: useRouter()
			};
		},

		methods: {
      onClickLogin() {
				this.router.push({ path: "/main" });
			},
		},
	});
</script>

<style src="./login-page.scss" lang="scss" scoped />
